// extracted by mini-css-extract-plugin
export var root = "NotFound-root-zhLvQ";
export var rootButton = "NotFound-root_button-KOIKL";
export var rootDescription = "NotFound-root_description-iNudi";
export var rootDescriptionBottom = "NotFound-root_descriptionBottom-ZDhZw";
export var rootHeading = "NotFound-root_heading-k8Umj";
export var rootTextWrapper = "NotFound-rootTextWrapper-ICquH";